import React from 'react';
import LazyRace from '../lazyRace/lazyRace';
import { BlindKaizoRace } from '../../../../../types/raceTypes';

interface RaceListProps {
	races: BlindKaizoRace[]
	raceFilePath: string
	/** If set, that race card mounts eagerly so scrolling to #race-{n} can find the DOM node. */
	focusRaceNumber?: number
}

export default function RaceList({ races, raceFilePath, focusRaceNumber }: RaceListProps) {
	return <>
		{races.map(race => (
			<LazyRace
				race={race}
				raceFilePath={raceFilePath}
				key={race._id}
				forceMount={focusRaceNumber !== undefined && race.number === focusRaceNumber}
			/>
		))}
	</>
}

